import classNames from 'classnames';

import {Icon} from 'components/UIKit';
import './styles.scss';

type Props = {
    label?: string;
    isDisabled?: boolean;
    className?: string;
    onClick: (event?: React.SyntheticEvent) => void;
    children: React.ReactNode;
};

export const SessionActionControl: React.FC<Props> = ({label, className, children, onClick, isDisabled = false}: Props) => (
    <div className='vs-session-action-control'>
        <div className={classNames('icon tw-flex-center', className)} onClick={onClick}>
            {children}
            {isDisabled && <Icon name='cross-line' color='alert' size='full' className='cross-icon' />}
        </div>
        {label && <div className='label'>{label}</div>}
    </div>
);
